import { FilterInputType, FilterTypes } from "../../../../Enums/FilterTypes";
import { CustomPbhRequestListFilterEnum } from "../../../../Enums/CustomPbhRequestListFilterEnum";

export const pbhOpenRequestExportColumn = [
  {
    header: "Ref No",
    key: "refNo",
  },
  {
    header: "Customer",
    key: "customerName",
  },
  {
    header: "Requirement Category",
    key: "requirementCategoryText",
  },
  {
    header: "Pn",
    key: "pn",
  },
  {
    header: "Pool Scope",
    key: "isPool",
  },
  {
    header: "DESTINATION",
    key: "airportCode",
  },
  {
    header: "Ac",
    key: "ac",
  },
  {
    header: "Request Date",
    key: "createdDate",
  },
  {
    header: "Requested Delivery Date",
    key: "requestedDeliveryDate",
  },
  {
    header: "Pbh Notes",
    key: "pbhNotes",
  },
];
export const pbhWaitingPoolScopeExportColumn = [
  {
    header: "Ref No",
    key: "refNo",
  },
  {
    header: "Customer",
    key: "customerName",
  },
  {
    header: "Requirement Category",
    key: "requirementCategoryText",
  },
  {
    header: "Pn",
    key: "pn",
  },
  {
    header: "DESTINATION",
    key: "airportCode",
  },
  {
    header: "Ac",
    key: "ac",
  },
  {
    header: "Request Date",
    key: "createdDate",
  },
  {
    header: "Requested Delivery Date",
    key: "requestedDeliveryDate",
  },
  {
    header: "Pbh Notes",
    key: "pbhNotes",
  },
];
export const pbhUnshippedSvcExportColumn = [
  {
    header: "Ref No",
    key: "refNo",
  },
  {
    header: "Customer",
    key: "customerName",
  },
  {
    header: "Requirement Category",
    key: "requirementCategoryText",
  },
  {
    header: "Request Status",
    key: "requestStatus",
  },
  {
    header: "Pn",
    key: "pn",
  },
  {
    header: "Pn Description",
    key: "pnDescription",
  },
  {
    header: "DESTINATION",
    key: "airportCode",
  },
  {
    header: "Ac",
    key: "ac",
  },
  {
    header: "Request Date",
    key: "createdDate",
  },
  {
    header: "Requested Delivery Date",
    key: "requestedDeliveryDate",
  },
  {
    header: "Wh",
    key: "displayWhCount",
  },
  {
    header: "Res",
    key: "displayResCount",
  },
  {
    header: "Alt. Pn",
    key: "displayAltPnCount",
  },
  // {
  //   header: 'Wo',
  //   key: 'displayWoCount'
  // },
  // {
  //   header: 'Ro',
  //   key: 'displayRoCount'
  // },
  // {
  //   header: 'Po/Ex',
  //   key: 'displayPoExCount'
  // },
  {
    header: "Rn",
    key: "displayRnCount",
  },
  {
    header: "Advanced XO",
    key: "advancedXo",
  },
  {
    header: "Pbh Notes",
    key: "currentPbhNote",
  },
];
export const pbhLocalRepairExportColumn = [
  {
    header: "Ref No",
    key: "refNo",
  },
  {
    header: "Customer",
    key: "customerName",
  },
  {
    header: "Requirement Category",
    key: "requirementCategoryText",
  },
  {
    header: "Request Status",
    key: "requestStatus",
  },
  {
    header: "Pn",
    key: "pn",
  },
  {
    header: "Pn Description",
    key: "pnDescription",
  },
  {
    header: "DESTINATION",
    key: "airportCode",
  },
  {
    header: "Ac",
    key: "ac",
  },
  {
    header: "Request Date",
    key: "createdDate",
  },
  {
    header: "Requested Delivery Date",
    key: "requestedDeliveryDate",
  },
  {
    header: "Advanced XO",
    key: "advancedXo",
  },
  {
    header: "Pbh Notes",
    key: "currentPbhNote",
  },
];
export const pbhReservedExportColumn = [
  {
    header: "Ref No",
    key: "refNo",
  },
  {
    header: "Customer",
    key: "customerName",
  },
  {
    header: "Requirement Category",
    key: "requirementCategoryText",
  },
  {
    header: "Pn",
    key: "pn",
  },
  {
    header: "Pn Description",
    key: "pnDescription",
  },
  {
    header: "DESTINATION",
    key: "airportCode",
  },
  {
    header: "Ac",
    key: "ac",
  },
  {
    header: "Request Date",
    key: "createdDate",
  },
  {
    header: "Requested Delivery Date",
    key: "requestedDeliveryDate",
  },
  {
    header: "Wh",
    key: "displayWhCount",
  },
  {
    header: "Res",
    key: "displayResCount",
  },
  {
    header: "Alt. Pn",
    key: "displayAltPnCount",
  },
  // {
  //   header: 'Wo',
  //   key: 'displayWoCount'
  // },
  // {
  //   header: 'Ro',
  //   key: 'displayRoCount'
  // },
  // {
  //   header: 'Po/Ex',
  //   key: 'displayPoExCount'
  // },
  {
    header: "Rn",
    key: "displayRnCount",
  },
  {
    header: "Advanced XO",
    key: "advancedXo",
  },
  {
    header: "Pbh Notes",
    key: "pbhNotes",
  },
];
export const pbhShippingProcessExportColumn = [
  {
    header: "Ref No",
    key: "refNo",
  },
  {
    header: "Customer",
    key: "customerName",
  },
  {
    header: "Requirement Category",
    key: "requirementCategoryText",
  },
  {
    header: "Pn",
    key: "pn",
  },
  {
    header: "Pn Description",
    key: "pnDescription",
  },
  {
    header: "DESTINATION",
    key: "airportCode",
  },
  {
    header: "Ac",
    key: "ac",
  },
  {
    header: "Request Date",
    key: "createdDate",
  },
  {
    header: "Requested Delivery Date",
    key: "requestedDeliveryDate",
  },
  {
    header: "Wh",
    key: "displayWhCount",
  },
  {
    header: "Res",
    key: "displayResCount",
  },
  {
    header: "Alt. Pn",
    key: "displayAltPnCount",
  },
  // {
  //   header: 'Wo',
  //   key: 'displayWoCount'
  // },
  // {
  //   header: 'Ro',
  //   key: 'displayRoCount'
  // },
  // {
  //   header: 'Po/Ex',
  //   key: 'displayPoExCount'
  // },
  {
    header: "Rn",
    key: "displayRnCount",
  },
  {
    header: "Pbh Notes",
    key: "pbhNotes",
  },
];
export const pbhRejectionProposalExportColumn = [
  {
    header: "Ref No",
    key: "refNo",
  },
  {
    header: "Customer",
    key: "customerName",
  },
  {
    header: "Requirement Category",
    key: "requirementCategoryText",
  },
  {
    header: "Request Status",
    key: "requestStatus",
  },
  {
    header: "Pn",
    key: "pn",
  },
  {
    header: "Pn Description",
    key: "pnDescription",
  },
  {
    header: "DESTINATION",
    key: "airportCode",
  },
  {
    header: "Ac",
    key: "ac",
  },
  {
    header: "Request Date",
    key: "createdDate",
  },
  {
    header: "Requested Delivery Date",
    key: "requestedDeliveryDate",
  },
  {
    header: "Wh",
    key: "displayWhCount",
  },
  {
    header: "Res",
    key: "displayResCount",
  },
  {
    header: "Alt. Pn",
    key: "displayAltPnCount",
  },
  // {
  //   header: 'Wo',
  //   key: 'displayWoCount'
  // },
  // {
  //   header: 'Ro',
  //   key: 'displayRoCount'
  // },
  // {
  //   header: 'Po/Ex',
  //   key: 'displayPoExCount'
  // },
  {
    header: "Rn",
    key: "displayRnCount",
  },
  {
    header: "Pbh Notes",
    key: "currentPbhNote",
  },
  {
    header: "Pbh Reserved Notes",
    key: "pbhReservedNotes",
  },
];

export const DetailFilterArray = [
  {
    source: "refNo",
    inputType: FilterInputType.Text,
    label: "Ref No",
  },
  {
    source: "customerCode",
    inputType: FilterInputType.Text,
    label: "Customer",
  },
  {
    source: "customerPo",
    inputType: FilterInputType.Text,
    label: "Customer Po",
  },
  {
    source: "acRegistration",
    inputType: FilterInputType.Text,
    label: "AC Reg",
  },
  {
    source: "airportCode",
    inputType: FilterInputType.Text,
    label: "Destination",
  },
  {
    source: "pn",
    inputType: FilterInputType.Text,
    label: "Pn",
  },
  {
    source: "remark",
    inputType: FilterInputType.Text,
    label: "Pbh Note",
  },
  {
    source: "pnDescription",
    inputType: FilterInputType.Text,
    label: "Pn Description",
  },
  {
    style: { width: "250px" },
    source: "requestedDeliveryDate",
    inputType: FilterInputType.Date,
    label: "Requested Delivery Date",
  },
  {
    source: "isLocalRepair",
    inputType: FilterInputType.Select,
    label: "Local Repair",
    filterTypeChangeDisable: true,
    filterType: FilterTypes.Equals,
    choices: [
      { id: true, name: "Yes" },
      { id: false, name: "No" },
    ],
    resettable: true,
  },
  {
    source: "customFilter",
    inputType: FilterInputType.Select,
    label: "Custom Filter",
    filterTypeChangeDisable: true,
    filterType: FilterTypes.Equals,
    choices: [
      { value: CustomPbhRequestListFilterEnum.ThirdParty, key: "3rd Party" },
      { value: CustomPbhRequestListFilterEnum.Aar, key: "AAR" },
      { value: CustomPbhRequestListFilterEnum.SsmKku, key: "SSM" },
    ],
    optionValue: "value",
    optionText: "key",
    resettable: false,
    defValue: CustomPbhRequestListFilterEnum.ThirdParty,
  },
];
export const CmsDetailFilterArray = [
  {
    source: "refNo",
    inputType: FilterInputType.Text,
    label: "Ref No",
  },
  {
    source: "customerCode",
    inputType: FilterInputType.Text,
    label: "Customer",
  },
  {
    source: "customerPo",
    inputType: FilterInputType.Text,
    label: "Customer Po",
  },
  {
    source: "acRegistration",
    inputType: FilterInputType.Text,
    label: "AC Reg",
  },
  {
    source: "airportCode",
    inputType: FilterInputType.Text,
    label: "Destination",
  },
  {
    source: "pn",
    inputType: FilterInputType.Text,
    label: "Pn",
  },
  {
    source: "remark",
    inputType: FilterInputType.Text,
    label: "Pbh Note",
  },
  {
    source: "pnDescription",
    inputType: FilterInputType.Text,
    label: "Pn Description",
  },
  {
    style: { width: "250px" },
    source: "requestedDeliveryDate",
    inputType: FilterInputType.Date,
    label: "Requested Delivery Date",
  },
  // {
  //   source: 'customFilter',
  //   inputType: FilterInputType.Select,
  //   label: 'Custom Filter',
  //   filterTypeChangeDisable: true,
  //   filterType: FilterTypes.Equals,
  //   choices: [ { value: CustomPbhRequestListFilterEnum.ThirdParty, key: '3rd Party' },{ value: CustomPbhRequestListFilterEnum.Aar, key: 'AAR' },{ value: CustomPbhRequestListFilterEnum.SsmKku, key: 'SSM' }],
  //   optionValue: 'value',
  //   optionText: 'key',
  //   resettable: false,
  //   defValue: CustomPbhRequestListFilterEnum.ThirdParty
  // },
];
export const pbhSuspendedExportColumn = [
  {
    header: "Ref No",
    key: "refNo",
  },
  {
    header: "Customer",
    key: "customerName",
  },
  {
    header: "Requirement Category",
    key: "requirementCategoryText",
  },
  {
    header: "Request Status",
    key: "requestStatus",
  },
  {
    header: "Pn",
    key: "pn",
  },
  {
    header: "Pn Description",
    key: "pnDescription",
  },
  {
    header: "DESTINATION",
    key: "airportCode",
  },
  {
    header: "Ac",
    key: "ac",
  },
  {
    header: "Request Date",
    key: "createdDate",
  },
  {
    header: "Requested Delivery Date",
    key: "requestedDeliveryDate",
  },
  {
    header: "Wh",
    key: "displayWhCount",
  },
  {
    header: "Res",
    key: "displayResCount",
  },
  {
    header: "Alt. Pn",
    key: "displayAltPnCount",
  },
  {
    header: "Rn",
    key: "displayRnCount",
  },
  {
    header: "Advanced XO",
    key: "advancedXo",
  },
  {
    header: "Pbh Notes",
    key: "currentPbhNote",
  },
];
export const DefaultFilterArray = [
  {
    source: "refNo",
    inputType: FilterInputType.Text,
    label: "Ref No",
  },
];
